export default "__VITE_ASSET__BKXYuDL9__"